
<div class="connect-common-page-header" *ngIf="cirfFormGroup && showMortgageNotesStep">
    <h2 class="header-text semi-bold-font">
        <div>Existing Mortgage(s) Notes</div>
    </h2>
    <form [formGroup]="cirfFormGroup">
        <div formGroupName="cirfMatterData" class="padding-top-10">
            <ng-template matStepLabel class="form-sub-header">Mortgage(s) Notes</ng-template>
            <div>
                <mat-form-field class="width-100" [dp-field-visibility]="mortgageNotesFieldKey">
                    <mat-label>Mortgage Notes</mat-label>
                    <textarea rows="3" matInput my-auto-focus formControlName="existingMortgageNotes"></textarea>
                    <mat-error>This field is required</mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
